// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3rm7g","vLegacy":"SelectSecondary_vLegacy__2mmlF","error":"SelectSecondary_error__2oVyu","disabled":"SelectSecondary_disabled__9_BKW"};